
function filterItems(liveSearch, value = ""){
    for(let liveSearchItem of liveSearch.querySelectorAll('.js-liveSearchItem')){
        if(liveSearchItem.innerText.toLowerCase().includes(value.toLowerCase())){
            liveSearchItem.style.display = "";
        }else{
            liveSearchItem.style.display = "none";
        }
    }
}

export function initLiveSearch(query = document.querySelectorAll('.js-liveSearch')){
    for(let liveSearch of query){
        let liveSearchInput = liveSearch.querySelector('.js-liveSearchInput');

        if(liveSearchInput){
            liveSearchInput.addEventListener("keyup",function (){
               filterItems(liveSearch,liveSearchInput.value);
            });
        }
    }
}